export const MOVE_SPEED = 2;
export const RUN_MULTIPLIER = 2;
export const MOUSE_SENSITIVITY = 0.002;
export const RECOIL_STRENGTH = 0.1;
export const RECOIL_DURATION = 150; // milliseconds
export const MUZZLE_FLASH_DURATION = 50; // milliseconds - very quick flash
export const MUZZLE_FLASH_LIGHT_INTENSITY = 15;
export const MUZZLE_FLASH_LIGHT_DISTANCE = 8;

// Zoom (ADS) tuning
export const DEFAULT_CAMERA_FOV = 75;
export const ZOOM_CAMERA_FOV = 50;
